import React from 'react';

const GlassCard = ({ title, children, className = '', hexCorner = true, actions, ...rest }) => (
  <div className={`glass-card ${hexCorner ? 'hex-corner' : ''} ${className}`} {...rest}>
    {title && (
      <div className="card-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>{title}</span>
        {actions && <div>{actions}</div>}
      </div>
    )}
    {children}
  </div>
);

export default GlassCard;
